module.exports = __webpack_public_path__ + "media/icons/info@3x-91fbc559.svg";